export default __webpack_public_path__ + "static/one-d7c43e55565e7c184166b3c8bb46e2b8.png";